import { gql } from '@apollo/client';

export const LOGOUT = gql`
mutation Logout($authToken: String) {
  logout(authToken: $authToken)
}
`;

export const LOGIN = gql`
mutation Login($email: String!, $password: String!, $challengeToken: String, $verifyOtp: String, $challengeName: String, $challengeSession: String) {
  login(email: $email, password: $password, challenge_token: $challengeToken, verifyOTP: $verifyOtp, challenge_name: $challengeName, challenge_session: $challengeSession) {
    _id
    email
    role
    authToken
    status
    QRCode
    challenge_session
    challenge_token
    challenge_name
    first_name
    last_name
    profile_pic
    customerData {
      customer_id
      customer_name
      customer_code
      region
    }
  }
}
`;

export const CREATE_PASSWORD = gql`
mutation CreatePassword($password: String!, $confirmPassword: String!, $email: String!, $token: String!) {
  createPassword(password: $password, confirm_password: $confirmPassword, email: $email, token: $token)
}
`;

export const INVITATION_LINK_EXPIRED = gql`
mutation ExpireStatusUpdate($email: String!) {
  expireStatusUpdate(email: $email)
}
`;

export const VERIFY_TOKEN_AUTHENTICITY = gql`
query Query($token: String!, $email: String!) {
  userByToken(token: $token,email: $email) {
    first_name
    last_name
    isExpired
    email
    status
  }
}
`;

export const FORGOT_PASSWORD = gql`
mutation ForgotPassword($email: String) {
  forgotPassword(email: $email)
}
`

export const RESET_PASSWORD = gql`mutation ConfirmForgotPassword($email: String!, $password: String!, $confirmPassword: String!, $verificationCode: String!) {
  confirmForgotPassword(email: $email, password: $password, confirm_password: $confirmPassword, verification_code: $verificationCode)
}`


export const CHANGE_PASSWORD = gql`mutation SetPassword($oldPassword: String!, $newPassword: String!) {
  setPassword(old_password: $oldPassword, new_password: $newPassword)
}`

export const SSO_VERIFY = gql`
  mutation SsoLogin($email: String!, $challengeToken: String) {
    ssoLogin(email: $email, challenge_token: $challengeToken) {
      first_name
      authToken
      _id
      email
      role 
      status
      QRCode
      challenge_session
      challenge_token
      challenge_name 
      last_name
      profile_pic
      customerData {
      customer_id
      customer_name
      customer_code
      }
    }
  }
`;